var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedCampaigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.97827C16.7956 4.97827 17.5587 5.29434 18.1213 5.85695C18.6839 6.41956 19 7.18262 19 7.97827C19 8.77392 18.6839 9.53698 18.1213 10.0996C17.5587 10.6622 16.7956 10.9783 16 10.9783",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 4.97827V15.9783C7.99976 16.2435 7.8944 16.4978 7.70686 16.6854C7.51933 16.8729 7.26497 16.9783 6.99976 16.9783H5.99976C5.73454 16.9783 5.48019 16.8729 5.29265 16.6854C5.10511 16.4978 4.99976 16.2435 4.99976 15.9783V10.9783",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.97846L14.524 1.20846C14.6555 1.09897 14.8154 1.02922 14.9851 1.00737C15.1548 0.985522 15.3271 1.01249 15.482 1.08511C15.6369 1.15774 15.7679 1.27301 15.8597 1.41741C15.9514 1.56182 16.0001 1.72938 16 1.90046V14.0565C16.0001 14.2275 15.9514 14.3951 15.8597 14.5395C15.7679 14.6839 15.6369 14.7992 15.482 14.8718C15.3271 14.9444 15.1548 14.9714 14.9851 14.9496C14.8154 14.9277 14.6555 14.858 14.524 14.7485L10 10.9785H2C1.73478 10.9785 1.48043 10.8731 1.29289 10.6856C1.10536 10.498 1 10.2437 1 9.97846V5.97846C1 5.71325 1.10536 5.45889 1.29289 5.27136C1.48043 5.08382 1.73478 4.97846 2 4.97846H10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCampaigner);
export default __webpack_public_path__ + "static/media/checkedCampaigner.a3089a5e.svg";
export { ForwardRef as ReactComponent };